import { useQuery } from '@tanstack/react-query';
import { getMealtimes } from '../../api/getMealtimes/getMealtimes';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';

export const useMealtimes = (menuId: string) => {
  const { showSnackbar } = useSnackbar();
  return useQuery({
    queryKey: [menuId, 'mealtimes'],
    queryFn: () => getMealtimes(menuId),
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
  });
};
